'use strict';
import _ from 'lodash';

export function authInterceptor($rootScope, $q, $cookies, $injector, Util) {
	'ngInject';
	//console.log("AUTH INTERCEPTOR LOADED");

	var state;
	return {
		// Add authorization token to headers
		request(config) {
			//console.log("Intercepting request");
			//NOTE: Creo que esto se podria quitar, ya que la cookie se recibe siempre en el servidor y si no hay authorization se coge el token de la cookie
			config.headers = config.headers || {};
			if ($cookies.get('token') && Util.isSameOrigin(config.url)) {
				config.headers.authorization = `Bearer ${$cookies.get('token')}`;
			}
			return config;
		},

		// Intercept 401s and redirect you to login
		responseError(response) {
			if (response.status === 401) {
				if (_.includes(response.config.url, "everlaps.com") || _.includes(response.config.url, "localhost"))
				{
					(state || (state = $injector.get('$state'))).go('login');
					// remove any stale tokens
					$cookies.remove('token');
				}
			}
			return $q.reject(response);
		}
	};
}



// WEBPACK FOOTER //
// ./client/components/auth/interceptor.service.js